import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid, gridConstants as gc } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getAllUnderwriterUsers } from '../../../services';

const styles = theme => ({});

export const UnderwriterUsersGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Client', field: 'clientName' },
    { headerName: 'Underwriter Code', field: 'underwriterCode' },
    { headerName: 'Email', field: 'email' },
    { headerName: 'First Name', field: 'fname' },
    { headerName: 'Last Name', field: 'lname' },
    { headerName: 'Title', field: 'title' },
    { headerName: 'Company', field: 'company' },
    { headerName: 'Record Mode', field: 'recordMode' },
    { headerName: 'Email Output', field: 'emailOutput' },
  ];

  const gridOptions = {};

  const getAllUnderwriterUsersAsync = async () => {
    try {
      const data = await getAllUnderwriterUsers();
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllUnderwriterUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        handleCellClick={evt => (window.location = `${window.location.href}/${evt.data.underWriterId}`)}
      />
    </div>
  );
});
